import { Component, Input } from '@angular/core';
import { Image } from '../../models/image';
import { Video } from '../../models/video';

export type MediaGridItem =
  | { type: 'image'; data: Image; modelName: string }
  | { type: 'video'; data: Video; modelName: string };

@Component({
  selector: 'app-media-grid',
  templateUrl: './media-grid.component.html',
  styleUrls: ['./media-grid.component.css']
})
export class MediaGridComponent {
  @Input() items: MediaGridItem[] = [];
  @Input() loading = false;
  @Input() emptyMessage = 'No media found.';
  @Input() emptyIcon = 'photo_library';
}
